import httpClient from "Api/httpClient";

const END_POINT = "/quote_requests";

const getQuoteRequests = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getQuoteRequest = (quote_request_id) => {
    if (!quote_request_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + quote_request_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printQuoteRequest = (quote_request_id) => {
    if (!quote_request_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?quote_request_id=" + quote_request_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createQuoteRequests = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateQuoteRequests = (payload, quote_request_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + quote_request_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteQuoteRequests = (quote_request_id) => {
    const DELETE_END_POINT = END_POINT + "/" + quote_request_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const createEstimateFromQuoteRequest = (payload, quote_request_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CREATE_END_POINT = "/quotes/create_from_quote_request/" + quote_request_id;
    return httpClient.post(CREATE_END_POINT, body);
};

const createRfqFromQuoteRequest = (payload, quote_request_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CREATE_END_POINT = "/rfqs/create_from_quote_request/" + quote_request_id;
    return httpClient.post(CREATE_END_POINT, body);
};

const createPurchaseOrderFromQuoteRequest = (payload, quote_request_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CREATE_END_POINT = "/purchase_orders/create_from_quote_request/" + quote_request_id;
    return httpClient.post(CREATE_END_POINT, body);
};

export {
    getQuoteRequests,
    getQuoteRequest,
    printQuoteRequest,
    createQuoteRequests,
    updateQuoteRequests,
    deleteQuoteRequests,
    createEstimateFromQuoteRequest,
    createRfqFromQuoteRequest,
    createPurchaseOrderFromQuoteRequest,
};
